/**
 * Truncate a string to a certain length and add '...' at the end
 * use this when truncated string is necessary
 * otherwise use TruncateText at src/components/TruncateText
 * @param text The text to truncate
 * @param maxLength The maximum length of the text
 * @returns The truncated text
 */
export const truncateText = (text: string, maxLength: number): string => {
  if (!text?.length) {
    return ''; // If the text is null or undefined, return an empty string
  }

  if (text.length <= maxLength) {
    return text; // If the text is already shorter than maxLength, return it as-is
  }

  return `${text.slice(0, maxLength)}...`; // Truncate the text and add '...' at the end
};
